import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'version',
  setup(__props, { expose: __expose }) {
  __expose();

const appVersion = VERSION;
const appEnv = ENVIRONMENT;
const appBuild = BUILD_HASH;
const versionString = computed(() => (`Version ${appVersion}${appEnv === 'development' ? '_DEV' : ''}`));

const __returned__ = { appVersion, appEnv, appBuild, versionString, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})